
import { IServiceMap } from '@/business/BusinessFormData'
import { IOrderForm } from '@/types/placeOrderTypes'
import { Component, Vue } from 'vue-property-decorator'
import BasePage from '../BasePage.vue'
import BasicInfo from '../components/BasicInfo.vue'
import UploadMaterial from '../components/Upload/UploadMaterial.vue'
import XdocProjectPlanForWord from '../components/XdocProjectPlanForWord.vue'
import _ from 'lodash'
import { editOrder } from '@/api/placeOrder'
import { Getter } from 'vuex-class'
import { IFormMap } from '@/store/modules/formMap'
import { getDefaultForm } from '../helper'
import { ICustomerAppKey, IOrganization } from '@/store/state'

@Component({
  components: {
    BasePage,
    BasicInfo,
    UploadMaterial,
    XdocProjectPlanForWord,
  },
})
export default class PlaceOrder extends Vue {
  @Getter('order_id') order_id!: string
  @Getter('customerAppKey') customerAppKey!: ICustomerAppKey
  @Getter('organization') organization!: IOrganization
  @Getter('formMap')
  formMap!: IFormMap

  defaultForm: IOrderForm = {} as IOrderForm
  form: IOrderForm = {} as IOrderForm
  formInfo: null | IServiceMap = null
  regBookName = false

  type = ''
  name = ''
  reEdit = false

  BaseMounted(serviceType: string, name: string) {
    this.type = serviceType
    this.name = name
    this.formInfo = this.formMap.formMap![serviceType]
    this.defaultForm = getDefaultForm(serviceType, this.formInfo, this.organization, this.customerAppKey, name)
  }

  FormChange(form: IOrderForm) {
    this.form = form
  }

  creatCheckForm(form: IOrderForm) {
    if (!form.book_name) return this.$message.error('请输入图书名称')
    if (!form.alias) return this.$message.error('请输入工单别名')
    if (!form.subject) return this.$message.error('请选择学科')
    if (!form.stage) return this.$message.error('请选择学段')
    if (!/^((?!\\|\/|:|\*|\?|"|<|>|\||').)*$/g.test(form.book_name)) {
      this.regBookName = true
      return this.$message.error('图书名称含有非法字符')
    }
    if (!/^((?!\\|\/|:|\*|\?|"|<|>|\||').)*$/g.test(form.alias)) {
      return this.$message.error('工单别名含有非法字符')
    }
  }

  submitCheckForm(bounds: any, callback: (val: boolean) => void) {
    // 文件检查
    if (!this.form.xdoc_planning?.length) {
      this.$message.error('请选择要制作的内容')
      return callback(true)
    }

    const names = this.form.xdoc_planning.map(item => item.name)
    if (Array.from(new Set(names)).length !== this.form.xdoc_planning.length) {
      this.$message.error('制作内容中有重名项目')
      return callback(true)
    }

    for (const i of this.form.xdoc_planning) {
      if (!/^((?!\\|\/|:|\*|\?|"|<|>|\||').)*$/g.test(i.name || '')) {
        this.$message.error('制作内容含有非法字符')
        return callback(true)
      }
      if (!i.origin_files!.filter(word => word.type === 1).length) {
        this.$message.error('制作内容中未选择 word 文件')
        return callback(true)
      }
      if (!i.config.style_config_data) {
        this.$message.error('制作内容中未选择方正样式')
        return callback(true)
      }
    }

    return callback(false)
  }

  screenForm(form: any) {
    const keys = Object.keys(form)
    const defaultKeys = Object.keys(this.defaultForm)
    const screenkeys = keys.filter(item => defaultKeys.includes(item))
    const screenForm: any = {}
    screenkeys.forEach(item => {
      screenForm[item] = form[item]
    })
    return screenForm
  }

  async handleSaveForm() {
    await editOrder({ ticket_id: this.order_id, ...this.screenForm(this.form) })
  }
}
